export var UI_TOGGLE_NAVDRAWER='UI_TOGGLE_NAVDRAWER';export var UI_VISIBILITY_CHANGE='UI_VISIBILITY_CHANGE';